/**
 * Pixelgipfel — header interactions.
 * - Megamenu open/close (click + Escape + outside-click)
 * - Language dropdown
 * - Burger placeholder (mobile drawer will be wired in a later milestone)
 * - Cart badge updates on cart:updated custom event
 */
(function () {
  'use strict';

  function once(el, key, fn) {
    if (!el || el.dataset[key] === '1') return;
    el.dataset[key] = '1';
    fn();
  }

  function closeAllMegas(except) {
    document.querySelectorAll('[data-pg-mega-parent][data-open="true"]').forEach(function (parent) {
      if (parent === except) return;
      parent.setAttribute('data-open', 'false');
      const btn = parent.querySelector('[data-pg-mega-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function closeAllLangs(except) {
    document.querySelectorAll('[data-pg-lang][data-open="true"]').forEach(function (wrap) {
      if (wrap === except) return;
      wrap.setAttribute('data-open', 'false');
      const btn = wrap.querySelector('[data-pg-lang-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function wireMega() {
    document.querySelectorAll('[data-pg-mega-parent]').forEach(function (parent) {
      once(parent, 'pgMegaWired', function () {
        const toggle = parent.querySelector('[data-pg-mega-toggle]');
        if (!toggle) return;
        parent.setAttribute('data-open', 'false');
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          const isOpen = parent.getAttribute('data-open') === 'true';
          closeAllMegas(parent);
          parent.setAttribute('data-open', isOpen ? 'false' : 'true');
          toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });
    });
  }

  // Taxonomie-Mega: Kategorie-Rail schaltet Panels (hover/focus)
  function wireMegaRail() {
    document.querySelectorAll('[data-pg-mega-tax]').forEach(function (mega) {
      once(mega, 'pgMegaTaxWired', function () {
        const rails = mega.querySelectorAll('[data-pg-mega-cat]');
        const panels = mega.querySelectorAll('[data-pg-mega-panel]');
        function activate(idx) {
          rails.forEach(function (r) {
            const on = r.getAttribute('data-pg-mega-cat') === idx;
            r.classList.toggle('is-active', on);
            r.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.hidden = p.getAttribute('data-pg-mega-panel') !== idx;
          });
        }
        rails.forEach(function (r) {
          const idx = r.getAttribute('data-pg-mega-cat');
          r.addEventListener('mouseenter', function () { activate(idx); });
          r.addEventListener('focus', function () { activate(idx); });
        });
      });
    });
  }

  // Mega öffnet bei Hover auf «Shop», bleibt offen bis:
  //  • ein anderer Top-Level Nav-Link gehovert wird
  //  • ausserhalb geklickt wird (siehe wireGlobal)
  //  • Escape gedrückt wird
  //  • Klick auf «Shop» toggelt
  // Kein Auto-Close beim Verlassen des Menüs.
  function wireMegaHover() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

    document.querySelectorAll('[data-pg-mega-parent]').forEach(function (parent) {
      once(parent, 'pgMegaHoverWired', function () {
        const btn = parent.querySelector('[data-pg-mega-toggle]');
        parent.addEventListener('mouseenter', function () {
          closeAllMegas(parent);
          parent.setAttribute('data-open', 'true');
          if (btn) btn.setAttribute('aria-expanded', 'true');
        });
      });
    });

    // Hover über ein anderes Nav-Item schliesst offene Mega-Menüs
    document.querySelectorAll('.pg-header__nav-item:not([data-pg-mega-parent]) .pg-header__nav-link').forEach(function (link) {
      once(link, 'pgMegaCloseOnHover', function () {
        link.addEventListener('mouseenter', function () { closeAllMegas(); });
      });
    });
  }

  function wireLang() {
    document.querySelectorAll('[data-pg-lang]').forEach(function (wrap) {
      once(wrap, 'pgLangWired', function () {
        const toggle = wrap.querySelector('[data-pg-lang-toggle]');
        if (!toggle) return;
        wrap.setAttribute('data-open', 'false');
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          const isOpen = wrap.getAttribute('data-open') === 'true';
          closeAllLangs(wrap);
          wrap.setAttribute('data-open', isOpen ? 'false' : 'true');
          toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });
    });
  }

  // --- Mobile drawer -------------------------------------------------------
  var mmOpener = null;

  function getMobileMenu() {
    return document.querySelector('[data-pg-mobile-menu]');
  }

  function openMobileMenu(opener) {
    const menu = getMobileMenu();
    if (!menu) return;
    mmOpener = opener || null;
    menu.hidden = false;
    void menu.offsetHeight; // force reflow so the transition runs
    menu.setAttribute('data-open', 'true');
    document.documentElement.classList.add('pg-mm-lock');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    const closeBtn = menu.querySelector('.pg-mobmenu__close');
    const panel = menu.querySelector('[data-pg-mm-panel]');
    (closeBtn || panel || menu).focus();
  }

  function closeMobileMenu() {
    const menu = getMobileMenu();
    if (!menu || menu.hidden || menu.getAttribute('data-open') !== 'true') return;
    menu.setAttribute('data-open', 'false');
    document.documentElement.classList.remove('pg-mm-lock');
    const panel = menu.querySelector('[data-pg-mm-panel]');
    let done = false;
    function finish() {
      if (done) return;
      done = true;
      menu.hidden = true;
    }
    if (panel) {
      panel.addEventListener('transitionend', function te(e) {
        if (e.target === panel && e.propertyName === 'transform') {
          panel.removeEventListener('transitionend', te);
          finish();
        }
      });
    }
    setTimeout(finish, 520); // fallback (reduced-motion / interrupted transition)
    document.querySelectorAll('[data-pg-burger]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (mmOpener) {
      mmOpener.focus();
      mmOpener = null;
    }
  }

  function trapMobileFocus(e) {
    const menu = getMobileMenu();
    if (!menu || menu.hidden || menu.getAttribute('data-open') !== 'true') return;
    const nodes = menu.querySelectorAll(
      'a[href], button:not([disabled]), input, summary, [tabindex]:not([tabindex="-1"])'
    );
    const visible = Array.prototype.filter.call(nodes, function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
    if (!visible.length) return;
    const first = visible[0];
    const last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function wireBurger() {
    document.querySelectorAll('[data-pg-burger]').forEach(function (btn) {
      once(btn, 'pgBurgerWired', function () {
        btn.addEventListener('click', function () {
          const menu = getMobileMenu();
          if (menu && menu.getAttribute('data-open') === 'true') {
            closeMobileMenu();
          } else {
            openMobileMenu(btn);
          }
        });
      });
    });

    const menu = getMobileMenu();
    if (!menu) return;
    once(menu, 'pgMmWired', function () {
      menu.querySelectorAll('[data-pg-mm-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeMobileMenu(); });
      });
      // Navigating away should close the drawer (covers same-page anchors too)
      menu.querySelectorAll('a[href]').forEach(function (a) {
        a.addEventListener('click', function () { closeMobileMenu(); });
      });
    });
  }

  function wireGlobal() {
    if (document.body.dataset.pgHeaderGlobal === '1') return;
    document.body.dataset.pgHeaderGlobal = '1';

    // Escape closes all menus; Tab traps focus inside the open mobile drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAllMegas();
        closeAllLangs();
        closeMobileMenu();
      } else if (e.key === 'Tab') {
        trapMobileFocus(e);
      }
    });

    // Click outside closes menus
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pg-mega-parent]')) closeAllMegas();
      if (!e.target.closest('[data-pg-lang]')) closeAllLangs();
    });
  }

  // Cart-count/subtotal live update via a lightweight event bus.
  // Any code that hits Shopify's cart AJAX endpoint should dispatch
  //   document.dispatchEvent(new CustomEvent('pg:cart-updated', { detail: cart }))
  // and the header will refresh in place.
  function formatMoneyCHF(cents) {
    // Fallback CHF formatter: uses shop's Shopify money format if available on window.moneyFormat
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, window.moneyFormat || 'CHF {{amount_with_apostrophe_separator}}');
      } catch (_) {}
    }
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return 'CHF ' + parts.join('.');
  }

  function updateHeaderCart(cart) {
    const count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    const total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    document.querySelectorAll('[data-pg-cart-count]').forEach(function (el) { el.textContent = String(count); });
    document.querySelectorAll('[data-pg-cart-total]').forEach(function (el) { el.textContent = formatMoneyCHF(total); });
    document.querySelectorAll('[data-pg-cart-link]').forEach(function (link) {
      link.classList.toggle('pg-cart-pill__empty', count === 0);
    });
  }

  document.addEventListener('pg:cart-updated', function (e) { updateHeaderCart(e.detail || {}); });

  function wireAll() {
    wireMega();
    wireMegaRail();
    wireMegaHover();
    wireLang();
    wireBurger();
    wireGlobal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }
  document.addEventListener('shopify:section:load', wireAll);
})();
